module.exports = __webpack_public_path__ + "img/vertical-orientation-icon.c63c645.svg";